export class Filters {
    static createYearsList(): any[] {
        const result = [];
        for (let i = new Date().getFullYear(); i >= 2013; i--) {
            result.push({key: i, value: i});
        }
        return result;
    }
}
